export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_NOTIFICATION = 'AUTH_NOTIFICATION';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const FETCH_PACKAGES = 'FETCH_PACKAGES';
